export default {
    customer: [
      '客服',// cn
      '客服',// tw
      'Customer Service',// en
      'Servicio al Cliente',// es
      'Atendimento ao Cliente', //pt
      '顧客サービス', //ja
      'บริการลูกค้า', //tha
      'Customer Service', //vi
      'Layanan Pelanggan', //idn
      'Müşteri servisi', //tr
    ],
    appDownload : [
        'APP下载',
        'APP下載',
        'APP Download',
        'Descarga de aplicaciones',
        'Baixar APP',
        'アプリダウンロード',
        'ดาวน์โหลดแอป',
        'Tải APP',
        'Unduh Aplikasi',
        'Uygulama indirme'
    ],
    multiTrade : [
        '多样化的交易',
        '多樣化的交易',
        'Diversified Transactions',
        'Transacciones Diversificadas',
        'Transações Diversificadas',
        '多様化の取引',
        'การซื้อขายอย่างมีความหลากหลาย',
        'Giao dịch đa dạng',
        'Transaksi terdiversifikasi',
        'Çeşitlendirilmiş İşlemler'
    ],
    multiIncome : [
        '多样化的收益',
        '多樣化的收益',
        'Diversified Benefits',
        'Beneficios Diversificados',
        'Benefícios Diversificados',
        '多様化の収益',
        'ผลกำไรอย่างมีความหลากหลาย',
        'Các lợi ích đa dạng',
        'Benefit terdiversifikasi',
        'Çeşitlendirilmiş Faydalar'
    ],
    topPlatForm : [
        '全球领先的数字货币交易平台',
        '全球領先的數字貨幣交易平臺',
        'Leading cryptocurrency trading platform around  the world',
        'Plataforma líder de comercio de criptomonedas en todo el mundo',
        'A principal plataforma de negociação de moeda digital do mundo',
        '世界をリードするデジタル通貨取引プラットフォーム',
        'แพลตฟอร์มการซื้อขายสกุลเงินดิจิทัลที่อยู่ในระดับชั้นนำของโลก',
        'Nền tảng giao dịch tiền kỹ thuật số hàng đầu thế giới',
        'Platform perdagangan mata uang digital terkemuka di dunia',
        'Dünyanın önde gelen dijital para birimi ticaret platformu'
    ],
    createAccount : [
        '创建账户',
        '創建帳戶',
        'Create an Account',
        'Crear una Cuenta',
        'Crie uma Conta',
        'アカウント作り',
        'สร้างบัญชี',
        'Tạo Tài Khoản',
        'Buat Akun',
        'Hesap oluştur'
    ],
    security : [
        '金融级安全',
        '金融級安全',
        'Financial Grade Security',
        'Seguridad de Grado Financiero',
        'Segurança de Nível Financeiro',
        '金融級セキュリティ',
        'ความปลอดภัยที่ในระดับการเงิน',
        'Bảo mật cấp độ tài chính',
        'Keamanan kelas Finansial',
        'Finansal Dereceli Güvenlik'
    ],
    risk : [
        '全方位金融风控系统和防盗系统，客户资产离线保存',
        '全方位金融風控系統和防盜系統，客戶資產離線保存',
        'Comprehensive financial risk control system anti-theft system, and assets offline storage for customers',
        'Sistema integral de control de riesgos financieros, sistema antirrobo y almacenamiento fuera de línea de activos para clientes',
        'Sistema abrangente de controle de risco financeiro, sistema antifurto e armazenamento offline de ativos para clientes',
        '全方位の金融リスクコントロールシステムと盗難を防ぐシステム、お客様資産オフライン保存',
        'ระบบควบคุมความเสี่ยงทางการเงินที่ครอบคลุม ระบบป้องกันการโจรกรรมอย่างครอบคลุม และการจัดเก็บทรัพย์สินของลูกค้าแบบออฟไลน์',
        'Hệ thống kiểm soát rủi ro tài chính toàn diện và hệ thống chống trộm, tài sản của khách hàng được lưu trữ ngoại tuyến',
        'Sistem pengendalian risiko keuangan yang komprehensif, sistem anti-pencurian, dan penyimpanan offline aset untuk pelanggan',
        'Müşteriler için kapsamlı finansal risk kontrol sistemi, hırsızlık önleme sistemi ve varlıkları çevrimdışı depolama',

    ],
    a : [
        '极速充提',
        '極速充提',
        'Rapid Charging and Withdrawal',
        'Carga y Retiro Rápidos',
        'Carregamento e Retirada Rápida',
        '速やかにチャージと換金',
        'การเติมและการถอนอย่างรวดเร็ว',
        'Nạp rút nhanh',
        'Top up dan withdraw cepat',
        'Hızlı Para Yatırma ve Çekme'
    ],
    b : [
        '24小时人工在线审核，确保不错过最佳投资机会',
        '24小時人工線上審核，確保不錯過最佳投資機會',
        "24-hour manual online audit to ensure you'll not missing the best investment opportunities",
        'Auditoría manual en línea las 24 horas para asegurarse de que no perderá las mejores oportunidades de inversión',
        'Auditoria online manual 24 horas para garantir que você não perderá as melhores oportunidades de investimento',
        'ベスト投資機会を逃さないよう、24時間人工オンライン審査',
        'มีเจ้าหน้าที่ตรวจสอบออนไลน์ตลอด 24 ชั่วโมงเพื่อให้แน่ใจว่าไม่พลาดโอกาสในการลงทุนที่ดีที่สุด',
        'Luôn online 24 tiếng kiểm tra,đảm bảo không sót cơ hội đầu tư nào',
        "Ulasan online manual 24 jam,Pastikan Anda tidak melewatkan peluang investasi terbaik",
        'En iyi yatırım fırsatlarını kaçırmamanızı sağlamak için 24 saat manuel çevrimiçi denetim'
    ],
    c : [
        "全球服务",
        "全球服務",
        'Global Service',
        'Servicio Global',
        'Serviço Global',
        'グローバルサービス',
        'การให้บริการทั่วโลก',
        'Dịch vụ toàn cầu',
        'Pelayanan Global',
        'Küresel Hizmet'
    ],
    d : [
        "全球服务覆盖，助您投资全球加密资产，与全球用户交易",
        "全球服務覆蓋，助您投資全球加密資產，與全球用戶交易",
        "Global service coverage helps you invest in global crypto assets and trade with global users",
        "La cobertura de servicio global lo ayuda a invertir en criptoactivos globales y comerciar con usuarios globales",
        "A cobertura de serviço global para ajudá-lo a investir em ativos criptográficos globais e negociar com usuários globais",
        "サービスが全世界にカバーされ、グローバルの暗号資産の投資に役立ち、全世界のユーザーと取引る",
        "ความครอบคลุมของการบริการทั่วโลกเพื่อช่วยให้คุณลงทุนในสินทรัพย์คริปโตของทั่วโลก และทำการซื้อขายกับผู้ใช้ของทั่วโลก",
        "Dịch vụ toàn cầu để giúp bạn đầu tư vào tài sản mã hóa quốc  và giao dịch với người dùng quốc tế",
        "Cakupan layanan global membantu Anda berinvestasi dalam aset kripto global dan berdagang dengan pengguna global",
        "Küresel hizmet kapsamı, küresel kripto varlıklarına yatırım yapmanıza ve küresel kullanıcılarla ticaret yapmanıza yardımcı olur"
    ],
    e : [
        '滑动浏览更多',
        '滑動流覽更多',
        'Swipe to view more',
        'Desliza para ver más',
        'Deslize para ver mais',
        'スライドしてもっとを見る',
        'เลื่อนดูเพิ่มเติม',
        'Vuốt để xem thêm',
        'Geser untuk melihat lebih banyak',
        'Daha fazlasını görmek için kaydırın'
    ],
    f : [
    '买卖加密货币',

        '買賣加密貨幣',

        'Buying and selling cryptocurrency',

        'Compra y venta de criptomonedas',
        'Compra e venda de criptomoedas',
        '暗号通貨を売買',
        'ซื้อขายคริปโตเคอร์เรนซี',
        'mua và bán tiền điện tử',
        'Jual Beli mata uang Kripto',
        'Kripto para birimi satın alma ve satma'
    ],
    g : [
    '在这里，拥有您的第一笔数字资产',

        '在這裏，擁有您的第一筆數字資產',

        'To have your first digital assets here',
        'Pata tener sus primeros activos digitales aquí',
        'Para ter seus primeiros ativos digitais aqui',
        'ここに、あなたの最初デジタル資産を持つ',
        'คุณสามารถถือสินทรัพย์ดิจิทัลชิ้นแรกของคุณ',
        'Hãy sở hữu tài sản kỹ thuật số đầu tiên của bạn ngay tại đây',
        'Miliki Aset digital pertama anda disini',
        'İlk dijital varlıklarınızı burada bulundurmak için'
    ],
    h : [
    '以更低保证金撬动更高杠杆',

        '以更低保證金撬動更高杠杆',

        'Higher leverage, lower margin',
        'Aproveche un mayor apalancamiento con un margen más bajo',
        'Alavancar maior alavancagem com margem menor',
        '更に低い保証金で更に高いレバレッジをこじ開ける',
        'ได้รับเลเวอเรจที่สูงขึ้นด้วยค่ามัดจำที่ต่ำกว่า',
        'Tận dụng đòn bẩy cao hơn với tỷ suất lợi nhuận thấp hơn',
        'Leverage yang lebih tinggi dengan margin yang lebih rendah',
        'Daha düşük marjla daha yüksek kaldıraçtan yararlanın'
    ],
    i : [
        '适当使用合约交易可在短时间内获得更高收益',
        '適當使用合約交易可在短時間內獲得更高收益',
        'Proper use of swap trading to achieve higher returns in a short time',
        'Uso adecuado del comercio de swap para lograr mayores rendimientos en poco tiempo',
        'O uso adequado da negociação de contratos pode obter retornos mais altos em um curto período de tempo',
        'スワップ取引を適当に使って短時間に更に高い収益を獲得できる',
        'การใช้สวอปอย่างเหมาะสมเพื่อให้ได้ผลกำไรที่สูงขึ้นในเวลาอันสั้น',
        'Sử dụng hợp đồng giao dịch đúng cách có thể nhận được lợi nhuận cao hơn trong một khoảng thời gian ngắn',
        'enggunaan perdagangan swap yang tepat untuk mencapai return yang lebih tinggi dalam waktu singkat',
        'Kısa sürede daha yüksek getiri elde etmek için takas ticaretinin doğru kullanımı'
],
        j : [
            "预测行情涨跌",
            "預測行情漲跌",
            "Forecast the rise and fall of the market",
            "Predecir el ascenso y la caída del mercado",
            "Preveja a ascensão e queda do mercado",
            "相場の騰落を予測",
            "ทำนายขาขึ้นและขาลงของตลาด",
            "Dự đoán sự lên xuống của thị trường",
            "Memprediksi naik turun pasar",
            "Piyasanın yükselişini ve düşüşünü tahmin edin"
        ],
            k : [
                "周期短，收益快",
                "週期短，收益快",
                "Short cycle with quick return",
                "Cucle corto con retorno rápido" ,
                "Ciclo curto com retorno rápido",
                "周期短い、収益早い",
                "รอบเวลาสั้น ได้ผลกำไรเร็ว",
                "Chu kỳ ngắn, thu hồi vốn nhanh",
                "Siklus yang pendek dengan return yang cepat",
                "Hızlı geri dönüşlü kısa döngü"
],
l : [
    "玩，就赚了",
    "玩，就賺了",
    "Just play and earn from it",
    "Solo juega y gana con ello",
    "Basta jogar e ganhar com isso",
    "遊べれば、稼ぐだ",
    "เพียงแค่เข้ามาเล่น ก็สามารถได้รับผลกำไร",
    "Chỉ cần chơi là có thể kiếm tiền",
    "Mainkan dan dapatkan",
    "Sadece oyna ve onunla kazan"
],
m : [
    "加密货币相关的各类竞猜游戏",
    "加密貨幣相關的各類競猜遊戲",
    "Various guessing games related to cryptocurrency",
    "Varios juegos de adivinanzas relacionados con criptomonedas",
    "Vários jogos de adivinhação relacionados à criptomoeda	",
    "暗号通貨に関する各種クイズゲーム	",
    "เกมตอบคำถามต่าง ๆ ที่เกี่ยวข้องกับคริปโตเคอร์เรนซี",
    "Các trò chơi khác nhau liên quan đến tiền điện tử"	,
    "Berbagai game kuis yang terkait dengan cryptocurrency"	,
    "Cryptocurrency ile ilgili çeşitli tahmin oyunları"
],
    n : [
    "扫描二维码下载APP",
    "掃描二維碼下載APP",
    "Scan the QR code to download app",
    "Escanea el código QR para descargar la aplicación ",
    "Digitalize o código QR para baixar o app",
       "QRコードをスキャンしてアプリをダウンロード",
        "สแกนรหัสคิวอาร์โค้ดเพื่อดาวน์โหลดแอป",
        "Quét mã QR để tải APP",
        "Scan kode QR untuk unduh app",
        "Uygulamayı indirmek için QR kodunu tarayın",
],
    o : [
    "请用手机扫描二维码访问，或手机浏览器访问：<br/><p>{link}</p>",
    "請用手機掃描二維碼訪問，或手機流覽器訪問：<br/><p>{link}</p>",
    "Please scan the QR code with your mobile phone to access it, or visit it by the browser: <br/><p>{link}</p>",
    "Por favor, escanea el código QR con su teléfono móvil para acceder a él, o visítelo con el navegador: <br/><p>{link}</p>",
    "Por favor, escaneie o código QR com seu celular para acessá-lo, ou visite-o pelo navegador: <br/><p>{link}</p>",
    "スマホンのQRコード或いはスマホンのブラウザで<br/><p>{link}</p>を訪問する",
        "โปรดสแกนคิวอาร์โค้ดด้วยโทรศัพท์มือถือของคุณเพื่อเข้าชม หรือเข้าชมผ่านเบราว์เซอร์มือถือ: <p>{link}</p>",
        "Vui lòng quét mã QR bằng điện thoại di động của bạn để truy cập hoặc truy cập trình duyệt trên điện thoại di động: <br/><p>{link}</p>",
        "Silahkan scan kode QR dengan ponsel anda untuk mengunjungi, atau kunjungi <br/><p>{link}</p> berikut dengan browser",
        "Erişmek için lütfen QR kodunu cep telefonunuzla tarayın veya tarayıcınız aracılığıyla ziyaret edin: <br/><p>{link}</p>",

],
p : [
    '首页',
    '首頁',
    'Home',
    'Página de Inicio',
    'Primeira Página',
    'ホームページ',
    'หน้าแรก',
    'Trang chủ',
    'Awal',
    'Ana Sayfa'
],
    q : [
        '现货',
        '現貨',
        'Spot',
        'Spot',
        'Spot',
        'スポット',
        'สปอร์ต',
        'Spot',
        'Spot',
        'Spot'
    ],
    r : [
        '合约',
        '合約',
        'Swap',
        'Swap',
        'Contrato',
        'スワップ',
        'สวอป',
        'Hợp đồng',
        'Swap',
        'Swap'
    ],
    s : [
        '二元期权',
        '二元期權',
        'Binary Option ',
        'Opción Binaria ',
        'Opção Binária ',
        'オプション',
        'ไบนารี่ ออปชั่น ',
        'Quyền chọn nhị phân ',
        'Opsi Biner ',
        'İkili Opsiyon '
    ],
    u : [
        '游戏',
        '遊戲',
        'Game',
        'Juego',
        'Jogo',
        'ゲーム',
        'เกม',
        'Trò chơi',
        'Permainan',
        'Oyun'
    ],
    backstage: [
      '代理后台',
      '代理後臺',
      'Agent Management System',
      'Sistema de Gestión de Agentes',
      'Sistema de Gestão de Agentes',
      '代理バックグラウンド',
      'ระบบการจัดการตัวแทนพื้นหลัง',
      'Đại lý hậu trường',
      'Sistem manajemen agen',
      'Temsilci Yönetim Sistemi'
    ],

    qiquan : ["期权",
        "期權",
        "Option",
        "Opción",
        "Opção",
        "オプション",
        "ตัวเลือก",
        "Tùy chọn",
        "Opsi",
        "Seçenekle"
       ],
    vv : [
        '秒合约',
        '秒合約',
        ' Seconds Contract',
        ' Contrato de Segundos',
        ' Contrato dos Segundos',
        '秒契約',
        ' สัญญาวินาที',
        ' Seconds Contract',
        ' Kontrak Seconds',
        ' Saniye Sözleşmesi',
    ],
    'yszc' : [
        '隐私政策和声明',
        '隱私政策和聲明',
        'Privacy Policy Statement',
        'Declaración y Política de Privacidad',
        'Política De Privacidade E Declaração',
        'プライバシーポリシーと声明',
        'นโยบายความเป็นส่วนตัวและคำชี้แจง',
        'Chính sách Bảo mật',
        'Pernyataan dan Kebijakan Privasi',
        'Gizlilik Politikası Bildirimi'
    ],
    'mzsm':[
        '免责声明',
        '免責聲明',
        'Legal Statement',
        'Descargo de Responsabilidad',
        'Declaração Legal',
        '免責声明書',
        'ข้อจำกัดความรับผิดชอบ',
        'Miễn trách nhiệm',
        'Pernyataan Penafian',
        'Yasal Açıklama'
    ],
    'ycyx' : [
        '原创游戏',
        '原創遊戲',
        'Original Games',
        ,
        ,
        ,
        ,
        ,
        ,
        ,
    ],

    'electron_index' : [
        '电游',
        '電遊',
        'Arcade',
        ,
        ,
        ,
        ,
        ,
        ,
        ,
    ],
    'sport_index' : [
        '体育',
        '體育',
        'Sports',
        ,
        ,
        ,
        ,
        ,
        ,
        ,
    ],
    'live_index' : [
        '真人',
        '真人',
        'Live',
        ,
        ,
        ,
        ,
        ,
        ,
        ,
    ]
}

